import { businessSummaryChartPreset } from "components/global/ChartJS/chartPresetsAndStyles";
import Signal from "libs/signals";

export const businessMyLoansSignal = Signal({
  applications: [],
  selectedApplication: null,
  businessSummaryChart: businessSummaryChartPreset,
  amountPaidBack: 0,
});
